import React from "react";
import { Section, Reveal, Eyebrow, SectionTitle, CTAButton } from "./ui";
import { tomos, educationalDisclaimer } from "./data";
export function Tomos() {
  return <Section id="tomos" className="bg-white" data-id="element-214" data-mp="139v1aq38grdd">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-215" data-mp="1h44c59ihhfnv">
        <Eyebrow data-id="element-216" data-mp="1cce1f2fmwpvx">Las 6 guías</Eyebrow>
        <SectionTitle data-id="element-217" data-mp="1cbb86nuuabcu">6 guías para no tener que empezar de cero cada vez.</SectionTitle>
        <p className="mt-4 text-sm leading-relaxed text-[var(--muted)] sm:text-base" data-id="element-218" data-mp="1r0h7scxla3l9">
          Cada tomo aborda un área diferente para que puedas consultar lo que necesitás cuando
          lo necesitás.
        </p>
      </Reveal>

      <div className="mt-8 grid gap-2.5 sm:mt-10 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3" data-id="element-219" data-mp="201f2u5q1v0rp">
        {tomos.map((t, i) => <Reveal key={t.n} delay={i % 3 * 0.05} data-id="element-220" data-mp="1vyioir7jlqtk" data-mpi={i}>
            <article className="flex h-full gap-3 rounded-2xl border border-[#e6eef5] bg-white p-3 text-left shadow-[0_14px_36px_-28px_rgba(23,50,77,0.6)] sm:flex-col sm:gap-0 sm:p-5" data-id="element-221" data-mp="5oyvt2pfjils">
              <img src={t.img} alt={`Tomo ${t.n}: ${t.title}`} className="h-28 w-auto flex-none rounded-lg object-contain drop-shadow-md sm:mb-4 sm:h-40 sm:w-full" loading="lazy" data-id="element-222" data-mp="34rhqonhixwwp" />
              <div className="flex flex-col" data-id="element-223" data-mp="3en2yj299xred">
                <span className="text-[10px] font-extrabold uppercase tracking-[0.14em] text-[var(--accent)]" data-id="element-224" data-mp="3jgnz92294zh9">
                  Tomo {t.n}
                </span>
                <h3 className="mt-0.5 font-serif-display text-base leading-tight text-[var(--ink)] sm:text-lg" data-id="element-225" data-mp="3sgao6odsoctf">
                  {t.title}
                </h3>
                <p className="mt-1.5 text-xs leading-snug text-[var(--muted)] sm:text-sm sm:leading-relaxed" data-id="element-226" data-mp="1aj15xvbdgau">
                  {t.desc}
                </p>
              </div>
            </article>
          </Reveal>)}
      </div>

      <Reveal delay={0.1} className="mt-7 text-center sm:mt-9" data-id="element-227" data-mp="280fuctzclc2f">
        <p className="mx-auto max-w-2xl text-[11px] leading-relaxed text-[#8b98a5]" data-id="element-228" data-mp="280pkchke7j84">
          {educationalDisclaimer}
        </p>
        <CTAButton className="mt-6" data-id="element-229" data-mp="1vy646d0tqbie">Quiero acceder a las 6 guías</CTAButton>
      </Reveal>
    </Section>;
}